const isUndefinedOrEmpty = (value) =>
  value === undefined ||
  (typeof value === 'object' &&
    value !== null &&
    Object.keys(value).length === 0);

export const preserveDashletStyles = (generatedConfig, existingState) => {
  const { dashletStyleConfig, customStylesEnabled } = existingState;
  const newState = { ...generatedConfig };
  if (
    isUndefinedOrEmpty(newState.dashletStyleConfig) &&
    dashletStyleConfig !== undefined
  ) {
    newState.dashletStyleConfig = dashletStyleConfig;
  }

  if (
    newState.customStylesEnabled === undefined &&
    customStylesEnabled !== undefined
  ) {
    newState.customStylesEnabled = customStylesEnabled;
  }

  return newState;
};
